import { Button,  } from "./Elements";
import { Modal  } from "./";
 





const InstallmentHtmlTable =({isOpenModal, setIsOpenModal, installmentTableHtml})=>{


    return (
        <Modal openModal={isOpenModal} setOpenModal={setIsOpenModal}
        dialogclass={"!max-w-[1000px]"}
      >
        <div dangerouslySetInnerHTML={{
          __html: installmentTableHtml
        }}>
        </div>
        <div className="mt-5 sm:mt-4 sm:flex sm:justify-end space-x-2">
          <Button
            color="primary"
            hover="primary"
            size="xs"
            callback={() => setIsOpenModal(false)}
          >
            Kapat
          </Button>
        </div>
      </Modal>
    );
}
export default InstallmentHtmlTable;